import { combineReducers } from "redux";
import authReducer from "./authReducer";
import venueReducer from "./venueReducer";
import cartReducer from "./cartReducer";

const rootReducer = combineReducers({
    auth: authReducer,
    venue: venueReducer,
    cart: cartReducer,
})

export default rootReducer;